import * as React from "react";
import { Card, Table, Tag, Button } from "antd";
import { NavLink } from "react-router-dom";

interface Role {
  __typename: "Role";
  ldapDN: string | null;
  ldapUUID: string | null;
  name: string;
  scopes: string[];
  default: boolean | null;
}

export interface Props {
  roles: Array<Role | null> | null;
  loading?: boolean;
}

export interface State {}

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text: string, role: Role) => (
      <>
        <NavLink to={`/roles/${role.name}`}>{role.name}</NavLink>
      </>
    )
  },

  {
    title: "Scopes",
    key: "scopes",
    dataIndex: "scopes",
    render: (scopes: string[], role: Role) => (
      <span>
        {scopes.map(scope => (
          <Tag color="red" key={role.name}>
            {scope}
          </Tag>
        ))}
      </span>
    )
  }
  /*{
    title: "Action",
    key: "action",
    render: (text: string, user: User) => (
      <span>
        <a href="javascript:;">Invite {user.name}</a>
        <Divider type="vertical" />
        <a href="javascript:;">Delete</a>
      </span>
    )
  }*/
];

export default class RoleList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Card
        title="All Roles"
        bodyStyle={{ padding: 0 }}
        style={{ marginTop: 30 }}
        extra={
          <NavLink to="/roles/add">
            <Button>Create</Button>
          </NavLink>
        }
      >
        <Table
          rowKey="name"
          loading={this.props.loading}
          columns={columns}
          dataSource={this.props.roles || []}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoleList/RoleList.tsx